import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import ReactJson from "react-json-view";
import { Card, CardBody, CardTitle, Col, FormGroup, Modal, Row } from 'reactstrap';

import GenericSpinner from "../genericComponents/GenericSpinner";
import { GenericTableButton } from "../buttons/buttonsActions";
import { showToastCustom } from "../toast/customToast";
import { logHistoryService } from "../../jwt/_services/security/logHistoryService";
import { TT_NEXT, TT_PREV } from "../i18n/toolTips";
import { error } from "../i18n/i18n";

export const LogHistoryModal = forwardRef((props, ref) => {
    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [parentItem, setParentItem] = useState(props.item);

    const [listItems, setListItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [jsonData, setJsonData] = useState("{}");

    useEffect(() => {
        if(parentItem && modal)
            loadHistory(parentItem);
    }, []);

    const loadHistory = (_parentItem) => {
        setLoading(true);

        logHistoryService.get(_parentItem.id)
            .then(result => {
                if (result){
                    setListItems(result);
                    setItemToView(result, selectedIndex)
                }
            })
            .catch(errorMessage => {
                setLoading(false);
                setListItems([]);
                showToastCustom(error, errorMessage);
            })
            .finally(() => setLoading(false))
    }

    const setItemToView = (_listItems, _index) => {
        try {
            setSelectedItem(_listItems[_index]);
            setJsonData(JSON.parse(_listItems[_index]?.data));
        } catch (ignored) {
            setJsonData("{}");
        }
    }

    const prevItem = () => {
        let _index = selectedIndex;

        if (selectedIndex > 0)
            _index = selectedIndex - 1;

        setSelectedIndex(_index);
        setItemToView(listItems, _index);
    }

    const nextItem = () => {
        let _index = selectedIndex;

        if (selectedIndex < listItems.length - 1)
            _index = selectedIndex + 1;

        setSelectedIndex(_index);
        setItemToView(listItems, _index);
    }


    // ----------------------------------------------
    //            FORM BEHAVIOR
    // ----------------------------------------------
    const showModal = () => {
        setModal(!modal);
    }

    useImperativeHandle(ref, () => ({
        showModal(_parentItem) {
            setParentItem(_parentItem);
            loadHistory(_parentItem);
            setModal(!modal);
        }
    }));

    return <Modal isOpen={modal} toggle={showModal} >
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                {
                    (selectedIndex + 1) + ' de ' + listItems.length + ' : ' +
                    selectedItem?.userName + ' - ' +
                    selectedItem?.action + ' - ' +
                    selectedItem?.registerDate
                }
                <div className="float-right">
                    <GenericTableButton toolTip={TT_PREV} icon={'fa-arrow-left'} permission={'search'} onClick={prevItem}/>
                    <GenericTableButton toolTip={TT_NEXT} icon={'fa-arrow-right'} permission={'search'} onClick={nextItem}/>
                </div>
            </CardTitle>
            <CardBody>
                {
                    loading ? <GenericSpinner /> : <Row>
                        <Col>
                            <FormGroup>
                                <ReactJson
                                    src = { jsonData }
                                    name = { selectedItem?.model }
                                    displayDataTypes = { false }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                }
            </CardBody>
        </Card>
    </Modal>
})